import { ChevronRight, MapPin, Star, UtensilsCrossed } from "lucide-react";
import { motion } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import useDistanceLabel from "../../../customHooks/useDistanceLabel";
import "./KitchenProfile.css";

const categories = ["Kitchen", "Showcase", "Offer", "Review", "Food", "Recipe"];

const KitchenProfile = ({ onTypeClick, data, isPending }) => {
  const distanceLabel = useDistanceLabel(data?.address?.lat, data?.address?.lng);

  return (
    <div className="home-content-shell pb-2">
      {/* Nav chips */}
      <div className="kp-category-bar">
        {categories.map((cat, idx) => (
          <button key={idx} className="kp-category-chip" onClick={() => onTypeClick(cat)}>
            {cat}
          </button>
        ))}
      </div>

      {/* Hero card */}
      <div className="kp-hero">
        <div className="kp-avatar-wrap">
          {isPending ? (
            <Skeleton circle height={80} width={80} />
          ) : (
            <img
              src={data?.kitchenLogo || "/Assets/Img/kitchen_default.png"}
              alt={data?.name}
              className="kp-avatar"
            />
          )}
        </div>

        <div className="kp-info">
          {isPending ? (
            <Skeleton height={28} width={220} />
          ) : (
            <h1 className="kp-name">{data?.name}</h1>
          )}

          <div className="kp-meta">
            <span className="kp-meta-chip">
              <Star size={12} fill="#facc15" color="#facc15" />
              {data?.reviews?.rating || 0}
              <span className="kp-meta-light">({data?.reviews?.count || 0})</span>
            </span>
            <span className="kp-meta-chip">
              <UtensilsCrossed size={12} />
              {data?.foodCount || 0} foods
            </span>
          </div>

          {isPending ? (
            <Skeleton height={16} width={200} className="mt-1" />
          ) : (
            <div className="kp-address">
              <MapPin size={12} />
              {data?.address?.text || "Address not available"}
              {distanceLabel && (
                <span className="kp-meta-light"> · {distanceLabel}</span>
              )}
            </div>
          )}

          {data?.specialty?.length > 0 && (
            <div className="kp-tags">
              {data.specialty.map((s, i) => (
                <span key={i} className="kp-tag">{s}</span>
              ))}
            </div>
          )}
        </div>

        <Link to={`/wish-order?sellerId=${data?._id}`} className="kp-wish-btn-wrap">
          <motion.button
            whileHover={{ backgroundColor: "#1B6DC1", color: "#fff", borderColor: "#1B6DC1" }}
            className="kp-wish-btn"
          >
            Any Wish? <ChevronRight size={14} />
          </motion.button>
        </Link>
      </div>

      {/* Chef section */}
      {(data?.sellerProfile?.user?.name || data?.chefDescription) && (
        <div className="kp-chef-row">
          <img
            src={data?.sellerProfile?.user?.avatar || "/Assets/Img/chef_default.png"}
            alt="Chef"
            className="kp-chef-img"
          />
          <div className="kp-chef-info">
            <h2 className="kp-chef-name">{data?.sellerProfile?.user?.name}</h2>
            {data?.restrictions?.length > 0 && (
              <p className="kp-restrictions">
                <strong>Restrictions:</strong> {data.restrictions.join(" • ")}
              </p>
            )}
            <p className="kp-chef-desc">
              {data?.chefDescription || "Chef description not available."}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default KitchenProfile;
